/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { Store } from '@ngxs/store';
import { MatDialog } from '@angular/material/dialog';
import { AttachDialogComponent } from './dialog/attach-dialog.component';

export class AttachCommand extends MapCommand {
    private store: Store;
    private dialog: MatDialog;

    private active = false;

    invoke(): void {
        if (!this.active) {
            this.showDialog();
        }
    }

    protected onCommandInit() {
        super.onCommandInit();
        this.store = this.deps['store'];
        this.dialog = this.deps['dialog'];
    }

    private showDialog() {
        const ref = this.dialog.open(AttachDialogComponent, {});
        ref.afterClosed().pipe().subscribe();
    }
}
